import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { ApolloProvider } from 'react-apollo'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-client-preset'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import createMuiTheme from 'material-ui/styles/createMuiTheme'
import red from 'material-ui/colors/red'
import { Provider as MobXProvider } from 'mobx-react'
import { GC_AUTH_TOKEN, PROJECT_TRACKER_ID, WHITE } from './constants'
import registerServiceWorker from './registerServiceWorker'
import App from './App'
import ResultsStore from './stores/ResultsStore'
import chartStore from './stores/chartStore'
import userReadingStore from './stores/userReadingStore'
import userProjectsStore from './stores/userProjectsStore'
import userBodyWeightStore from './stores/userBodyWeightStore'
import myProjectsStore from './stores/myProjectsStore'
import myProjectsPrefStore from './stores/myProjectsPrefStore'
import BooksStore from './stores/BooksStore'
import BookPrefStore from './stores/BookPrefStore'
import TrackersStore from './stores/TrackersStore'
import TrackerPrefStore from './stores/TrackerPrefStore'
import userSleepStore from './stores/userSleepStore'
import userSleepPrefStore from './stores/userSleepPrefStore'
import userReadingPrefStore from './stores/userReadingPrefStore'
import userProjectsPrefStore from './stores/userProjectsPrefStore'
import userTimelineStore from './stores/userTimelineStore'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: 'rgba(80, 227, 194, 0.4)',
      contrastText: 'lightgrey'
    },
    secondary: {
      main: 'rgba(144, 238, 144, 0.5)',
      contrastText: WHITE
    },
    error: red
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'capitalize',
        fontWeight: 100
      }
    }
  }
})

const middlewareAuthLink = new ApolloLink((operation, forward) => {
  const token = global.localStorage.getItem(GC_AUTH_TOKEN)
  global.localStorage.setItem(PROJECT_TRACKER_ID, '')
  const authorizationHeader = token ? `Bearer ${token}` : null
  operation.setContext({
    headers: {
      authorization: authorizationHeader
    }
  })
  return forward(operation)
})
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_SIMPLE_API_ENDPOINT
})
const httpLinkWithAuthToken = middlewareAuthLink.concat(httpLink)
const apolloClient = new ApolloClient({
  link: httpLinkWithAuthToken,
  cache: new InMemoryCache()
})

// create the mobx stores
const stores = {
  results: new ResultsStore(),
  resultChart: new chartStore(),
  resultUserReading: new userReadingStore(),
  resultUserProjects: new userProjectsStore(),
  resultUserReadingPref: new userReadingPrefStore(),
  resultUserProjectsPref: new userProjectsPrefStore(),
  resultUserBodyWeight: new userBodyWeightStore(),
  resultBooks: new BooksStore(),
  resultBookPref: new BookPrefStore(),
  resultMyProjects: new myProjectsStore(),
  resultMyProjectsPref: new myProjectsPrefStore(),
  resultTrackers: new TrackersStore(),
  resultTrackerPref: new TrackerPrefStore(),
  resultUserSleep: new userSleepStore(),
  resultUserSleepPref: new userSleepPrefStore(),
  resultUserTimeline: new userTimelineStore()
}

ReactDOM.render(
  <BrowserRouter>
    <ApolloProvider client={apolloClient}>
      <MobXProvider {...stores}>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </MobXProvider>
    </ApolloProvider>
  </BrowserRouter>,
  document.getElementById('root')
)

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js